import React from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HelpIcon from '@mui/icons-material/Help';
import './FormTitleWithNavigationBack.scss'
import TooltipComponent from "../tooltip/tooltipComponent";

export interface FormTitleWithNavigationBackProps {
    title: string;
    tooltipData?: string;
    handleClick?: any;
}

const FormTitleWithNavigationBack = (props: FormTitleWithNavigationBackProps) => {
        const {title, tooltipData, handleClick} = props;

        return (
            <div className="form-title-navigate-back-component-wrapper">
                {
                    handleClick &&
                    <div className="back-navigation-wrapper" onClick={handleClick}>
                        <ArrowBackIosIcon className="navigate-back-icon"/>
                        <div className={'form-back-navigation-title'}>Back</div>
                    </div>

                }
                <div className="form-title-with-navigation">
                    <div className="form-title">
                        {title}
                    </div>
                    {tooltipData ?
                        <TooltipComponent tooltip={tooltipData} arrow={true}>
                            <span className="mrg-left-10" id={'tooltip_' + tooltipData}><HelpIcon color={'action'}/></span>
                        </TooltipComponent> : ''
                    }
                </div>
            </div>
        )
    }

;

export default FormTitleWithNavigationBack;
